<template>
  <div>
    <app-dashboard> </app-dashboard>
  </div>
</template>

<script>
import Dashboard from "@/components/BookingApp/AdminView/Dashboard.vue";

export default {
  name: "Home",
  components: {
    appDashboard: Dashboard,
  },
  created: function () {
    console.log("Admin home created");
  },
};
</script>

<style>
</style>